import * as React from 'react';
import {SVGProps} from 'react';

export const SendInputIcon = ({
  fill = '#000',
  opacity = 0.38,
  ...props
}: SVGProps<SVGSVGElement> & {fill?: string}) => (
  <svg
    width={13}
    height={12}
    fill="none"
    {...props}>
    <path
      fill={fill}
      d="M1.937 11.022a.735.735 0 0 1-.72-.065.715.715 0 0 1-.34-.636V7.445L6.392 6 .876 4.555V1.679c0-.277.114-.489.34-.637a.735.735 0 0 1 .721-.064L12.164 5.3c.313.138.469.371.469.7 0 .329-.156.562-.469.7L1.937 11.022Z"
      opacity={opacity}
    />
  </svg>
);
